import {Model, ModelMixin} from '../../common/model.class';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class State extends ModelMixin() implements Model<State> {

    TYPE = State;
    static projectionInformation = new ProjectionInformation('state');

    public code: string;
    public name: string;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/country/state.model.ts